<div class="pdf-page app-aul-008-24" id="aul00824">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>CLAIMS REPORTING INFORMATION</b>
  </p>
  <div class="font-small">
    <p>
      The following is useful information which will expedite the handling of
      claims and protect your rights under your policy of insurance. Promptly
      reporting an event that could lead to a claim, as required by your policy,
      allows us to promptly assess your claim and provide a fast and fair claims
      service.
      <b
        >Please refer to your Policy for your duties in the event of loss or
        damage.</b
      >
    </p>
    <p>
      To report a claim, please contact our appointed claims management service
      provider:
    </p>
    <p class="mb-0">Triton Claims Management LLC</p>
    <p class="mb-0">2400 Lakeview Parkway</p>
    <p class="mb-0">Suite 475</p>
    <p class="mb-0">Alpharetta</p>
    <p class="mb-0">Georgia 30009</p>
    <p class="mb-0">USA</p>
    <p>
      <a href="http://www.tritonclaims.com/" target="_blank" class="link"
        >http://www.tritonclaims.com</a
      >
    </p>
  </div>
  <br />
  <div class="font-medium" style="text-align: center">
    <p class="mb-0">
      <b>You may contact them 24 hours a day and 7 days a week by calling </b>
    </p>
    <p>
      <b
        >(800) 537-8023 or via email at<span>
          <a class="link" href="mailto:claims@tritonclaims.com"
            >claims&#64;tritonclaims.com</a
          ></span
        ></b
      >
    </p>
  </div>
  <br />
  <div class="font-small">
    <p>
      <b
        >When reporting a claim please be prepared to provide as much of the
        following information as possible:</b
      >
    </p>
    <ul>
      <li>Your policy number</li>
      <li>Date, time and location of the loss/accident</li>
      <li>Details of the loss/accident</li>
      <li>Name, address and phone number of any involved parties</li>
      <li>
        If applicable, name of law enforcement agency or fire department along
        with the incident number
      </li>
    </ul>
    <p>
      <b
        >Please refer to your policy for specific claim reporting
        requirements.</b
      >
    </p>
    <p>
      In the event of loss or damage, you are obligated to take all reasonable
      steps to protect the Covered Property from further damage and keep a
      record of your expenses necessary to protect the Covered Property, for
      consideration in the settlement of the claim. This will not increase the
      Limit of Insurance. Failure to take necessary action can result in
      prejudice of your rights under your policy.
    </p>
    <br />
    <br />
    <p>
      <b>
        FOR YOUR PROTECTION STATE LAW REQUIRES THE FOLLOWING STATEMENT TO APPEAR
        ON THIS POLICY: ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT
        CLAIM FOR PAYMENT OF LOSS OR BENEFIT WITH THE INTENT TO DEFRAUD OR
        DECEIVE ANY INSURER IS GUILTY OF A CRIME AND MAY BE SUBJECT TO CRIMINAL
        AND CIVIL PENALTIES AND DENIAL OF INSURANCE BENEFITS.
      </b>
    </p>
  </div>
</div>
